/************
 Sticky ATC
 ************/
let stickyATCObserver = new IntersectionObserver(
    (entries) => {
        entries.forEach((entry) => {
            const atcWrapper = document.querySelector("#productATCWrapper");

            if (entry.isIntersecting) {
                document.querySelector("#productATCWrapper").classList.remove("sticky");
            } else {
                document.querySelector("#productATCWrapper").classList.add("sticky");
            }
        });
    },
    {
        threshold: 0.1,
    }
);

stickyATCObserver.observe(document.querySelector("#product"));

/**************
 Product Variants
 ***************/

// Select mixed berries
if (
    document.querySelector(
        `.productOptionItemValuesLabelInput[value="Mixed Berries"]`
    )
) {
    document.querySelector(
        `.productOptionItemValuesLabelInput[value="Mixed Berries"]`
    ).checked = true;
}

// update active variant on input changes
document.querySelectorAll("#product input").forEach(function (element) {
    element.addEventListener("change", function () {
        updateProduct();
    });
});

const backgroundColors = {
    "Pina Colada": "linear-gradient(120deg, #CCBB0B, #FFE900 100%)",
    "Lemon/Lime":
        "linear-gradient(120deg, rgba(46, 155, 28, 1), rgba(68, 214, 44, 1) 100%)",
    "Mixed Berries": "linear-gradient(120deg, #B92D83, #FF3EB5 100%)",
    "Peach Crush": "linear-gradient(120deg, #ff7276, #ff4828 100%)",
};

function updateJunipStarColor() {
    if (
        document.querySelector("#product").dataset.flavor === "Mixed Berries" ||
        document.querySelector("#product").dataset.flavor === "Peach Crush" ||
        document.querySelector("#product").dataset.flavor === "Lemon/Lime"
    ) {
        document.documentElement.style.setProperty("--junipStarColor", "#FFE900");
    } else {
        document.documentElement.style.setProperty("--junipStarColor", "#00C503");
    }
}

function updateNavColor() {
    const currentFlavor = document.querySelector("#product").dataset.flavor;

    if (
        currentFlavor === "Mixed Berries" ||
        currentFlavor === "Lemon/Lime" ||
        currentFlavor === "Peach Crush"
    ) {
        document.documentElement.style.setProperty("--navLinkColor", "#FFFFFF");
        document.documentElement.style.setProperty("--navLogoFill", "#FFFFFF");
        document.documentElement.style.setProperty("--cartIconFill", "#FFFFFF");
        document.documentElement.style.setProperty("--cartCountColor", "#000000");
        document.documentElement.style.setProperty("--accountIconFill", "#FFFFFF");
        document.documentElement.style.setProperty(
            "--hamburgerIconFill",
            "#FFFFFF"
        );
    } else if (currentFlavor === "Pina Colada") {
        document.documentElement.style.setProperty("--navLinkColor", "#000000");
        document.documentElement.style.setProperty("--navLogoFill", "#000000");
        document.documentElement.style.setProperty("--cartIconFill", "#000000");
        document.documentElement.style.setProperty("--cartCountColor", "#FFFFFF");
        document.documentElement.style.setProperty("--accountIconFill", "#000000");
        document.documentElement.style.setProperty(
            "--hamburgerIconFill",
            "#000000"
        );
    }
}

const repeatVariantMap = {
    // -------------
    // Lemon/Lime
    // -------------
    // 30 stikur
    44751437201546: "a318ad62-4db6-44e2-b0f6-f731a5eb6ccc",
    // 60 stikur
    44751437234314: "5e8c649c-e835-412d-8ef4-261b61759901",
    // 90 stikur
    44751437267082: "ec0305c8-4ab5-434b-89df-017a19f5ff29",

    // Mixed Berries
    // -------------
    // 30 stikur
    44751437070474: "4e73c254-d2e5-403d-a5a3-6152a3d31e0d",
    // 60 stikur
    44751437103242: "a92b46f0-85e2-4004-a515-4b7984d0bcc0",
    // 90 stikur
    44751437136010: "88f1a199-bdc6-443c-b656-70d4dc365ac8",

    // -------------
    // Pina Colada
    // -------------
    // 30 stikur
    44751436939402: "ae1b245d-3e23-496c-993b-98131af4394d",
    // 60 stikur
    44751436972170: "97f28018-a59e-4718-8efe-0f039aa340f1",
    // 90 stikur
    44751437004938: "dfe189d7-e057-4bb5-bfa0-fb86f1cefb3b",

    // -------------
    // Peach Crush
    // -------------
    // 30 stikur
    45773488357514: "7c831367-c350-486e-a75a-08069b1288a8",
    // 60 stikur
    45773488390282: "75ea12b7-8da6-4811-94b1-b3009bfc1038",
    // 90 stikur
    45773488423050: "9fc23845-5744-4bd0-a74c-201ff3aed9eb",
};

function toggleSubscriptionAvailability(variant) {
    console.log("toggleSubscriptionAvailability", Object.keys(repeatVariantMap));
    const showSubscriptionOption = Object.keys(repeatVariantMap).includes(
        variant.id.toString()
    );

    if (showSubscriptionOption) {
        document
            .querySelector(".productSellingPlans")
            .classList.remove("repeatDisabled");
    } else {
        document
            .querySelector(".productSellingPlans")
            .classList.add("repeatDisabled");
        toggleRepeatSelector(false);
        // uncheck subscription
        document.querySelector(`input[id="otp"]`).checked = true;
    }
}

// update active variant
function updateProduct() {
    // default fall back
    if (product.variants.length === 1) {
        // default fallback
        activeVariant = product.variants[0];
    } else {
        // collect options from inputs
        let options = [];
        document.querySelectorAll(`.productOptionItem`).forEach((group) => {
            options.push(group.querySelector(`input:checked`).value);
        });

        // find new variant based on the options
        activeVariant = product.variants.find((variant) => {
            return JSON.stringify(variant.options) === JSON.stringify(options);
        });
    }

    if (activeVariant === null || activeVariant === undefined) {
        // check if variant wasn't found
        document.querySelector("#productATC").disabled = true;
        document.querySelector("#productATC").textContent = "Not Available";
        return;
    }

    // Set product flavor style
    if (Object.hasOwn(backgroundColors, activeVariant.option1)) {
        // Switch bg color according to variant
        document.querySelector("#product").style.background =
            backgroundColors[activeVariant.option1];

        // set class on variant options
        document.querySelector("#product").dataset.flavor = activeVariant.option1;
    }

    // update nav color
    updateNavColor();

    // update star colors
    updateJunipStarColor();

    // update colors for variant
    updateBackgroundForVariant(activeVariant.id);
    updateColorsForVariant(activeVariant.id);

    // update image
    document.querySelector(".productImage.active")?.classList.remove("active");

    const imageForVariant = Array.from(document.querySelectorAll(".productImage")).find(image => {
        return image.dataset.variants && JSON.parse(image.dataset.variants).includes(activeVariant.id);
    });

    const variantMetafieldImage = Object.hasOwn(variantMetafieldImages, activeVariant.id);

    if (imageForVariant) {
        imageForVariant.classList.add("active");
    } else {
        document.querySelector(".productImage").classList.add("active");
    }

    toggleSubscriptionAvailability(activeVariant);

    // Free shipping
    const freeShippingVariants = [
        "60 sticks",
        "90 sticks",
        "60 stikur",
        "90 stikur",
    ];

    // Translation
    document.querySelector("#productPriceReal").textContent = `${price(
        activeVariant.price,
        true
    )} ${
        freeShippingVariants.includes(
            activeVariant.option2
                ?.replace(" (FRÍ SENDING)", "")
                .replace(" (Free Shipping)", "")
        )
            ? `+ ${document.querySelector("#productPrice").dataset.freeShippingLang}`
            : ""
    }`;

    if (activeVariant.compare_at_price > activeVariant.price) {
        document.querySelector("#productPriceReal").classList.add("sale");
        document.querySelector("#productPriceCompare").textContent = price(
            activeVariant.compare_at_price,
            true
        );
        document.querySelector(
            "#productPriceSavings"
        ).textContent = `Save ${Math.round(
            ((activeVariant.compare_at_price - activeVariant.price) * 100) /
            activeVariant.compare_at_price
        )}%`;
    } else {
        document.querySelector("#productPriceReal").classList.remove("sale");
        document.querySelector("#productPriceCompare").textContent = "";
        document.querySelector("#productPriceSavings").textContent = "";
    }

    // check if subscription is selected
    if (document.querySelector(`input[id="repeat"]:checked`)) {
        const subscriptionDiscountPercentage = 15;

        // set real price to discount savings
        document.querySelector("#productPriceReal").textContent = price(
            activeVariant.price * (1 - subscriptionDiscountPercentage / 100),
            true
        );

        // set compare price to normal variant price
        document.querySelector("#productPriceCompare").textContent = price(
            activeVariant.price,
            true
        );

        // update savings
        document.querySelector(
            "#productPriceSavings"
        ).textContent = `Sparaðu ${subscriptionDiscountPercentage}%`;
    }

    // Update ATC product info
    document.querySelector("#productATCProductInfoText").innerHTML = `
    ${activeVariant.name
        .replace("/", " ")
        .replace(" (FRÍ SENDING)", "")
        .replace(" (Free Shipping)", "")}
    <br>
    ${price(activeVariant.price, true)}
    `;

    document.querySelector("#productATCProductInfoImg").src =
        activeVariant.featured_image.src;

    // check if the variant is in stock
    if (activeVariant.available) {
        document.querySelector("#productATC").classList.add("primary");
        document.querySelector("#productATC").disabled = false;
        document.querySelector("#productATCLabel").textContent =
            document.querySelector("#productATC").dataset.lang;
    } else {
        document.querySelector("#productATC").classList.remove("primary");
        document.querySelector("#productATC").disabled = true;
        document.querySelector("#productATCLabel").textContent = "Sold Out";
    }

    // update url with variant id so the selected options are maintained on refresh
    let url = new URL(window.location.href);
    url.searchParams.set("variant", activeVariant.id);
    window.history.replaceState({}, "", url);
}

function updateBackgroundForVariant(variantID) {
    // exit if this variant does not have a background setting
    if (!Object.hasOwn(variantBackgrounds, variantID)) {
        return;
    }

    // update bg color var
    document.documentElement.style.setProperty(
        "--productBackground",
        `linear-gradient(120deg, ${variantBackgrounds[variantID][0]}, ${variantBackgrounds[variantID][1]} 100%)`
    );
}

function updateColorsForVariant(variantID) {
    // exit if this variant does not have a background setting
    if (!Object.hasOwn(variantPDPColors, variantID)) {
        return;
    }

    // update text color var
    document.documentElement.style.setProperty(
        "--productTextColor",
        `${variantPDPColors[activeVariant.id][0]}`
    );

    // update border color var
    document.documentElement.style.setProperty(
        "--productOptionBorderColor",
        `${variantPDPColors[activeVariant.id][1]}`
    );

    // update product option background color var
    document.documentElement.style.setProperty(
        "--productOptionBackgroundColor",
        `${variantPDPColors[activeVariant.id][2]}`
    );

    // update product option text color var
    document.documentElement.style.setProperty(
        "--productOptionTextColor",
        `${variantPDPColors[activeVariant.id][3]}`
    );

    // update review stars
    document.documentElement.style.setProperty(
        "--junipStarColor",
        variantPDPColors[activeVariant.id][2]
    );

    // update nav color
    document.documentElement.style.setProperty(
        "--navLinkColor",
        variantPDPColors[activeVariant.id][0]
    );
    document.documentElement.style.setProperty(
        "--navLogoFill",
        variantPDPColors[activeVariant.id][0]
    );
    document.documentElement.style.setProperty(
        "--cartIconFill",
        variantPDPColors[activeVariant.id][0]
    );
    document.documentElement.style.setProperty(
        "--cartCountColor",
        variantPDPColors[activeVariant.id][0] === "#000000" ? "#FFFFFF" : "#000000"
    );
    document.documentElement.style.setProperty(
        "--accountIconFill",
        variantPDPColors[activeVariant.id][0]
    );
    document.documentElement.style.setProperty("--hamburgerIconFill", "#FFFFFF");
}

/****************
 * Product Quantity
 */

let quantity = 1;

function getSelectedSellingPlan() {
    // find checked plan
    let selectedPlan = document.querySelector(
        `.productSellingPlan input:checked:not([value="otp"])`
    );

    // return plan
    return selectedPlan ? selectedPlan.value : null;
}

function translateLabel(label, language = "is") {
    const translations = {
        frequency: {
            is: "Tíðni",
            en: "Frequency",
        },
        YEAR: {
            is: "ára",
            en: "years",
        },
        WEEK: {
            is: "vikna",
            en: "weeks",
        },
        MONTH: {
            is: "mánaða",
            en: "months",
        },
        DAY: {
            is: "daga",
            en: "days",
        },
        apart: {
            is: "fresti",
            en: "apart",
        },
    };

    return translations[label][language];
}

/**************
 Product ATC
 ***************/

function getRepeatProductUUID(variantId) {
    return repeatVariantMap[variantId];
}

document
    .querySelector("#productATC")
    .addEventListener("click", async function () {
        // add loading animation
        this.classList.add("loading");

        const sellingPlan = getSelectedSellingPlan();

        let formData = {
            items: [
                {
                    quantity: quantity,
                    id: activeVariant.id,
                },
            ],
        };

        // check if we're on iceland and sub is selected and redirect to repeat
        if (shopDomain === "happyhydrate.is" && sellingPlan === "repeat") {
            // remove loading animation
            this.classList.remove("loading");
            const selectedLanguage = "is";

            const repeatForm = document.querySelector(
                "#repeatSubscriptionPicker"
            ).dataset;

            const repeatProductId = getRepeatProductUUID(activeVariant.id);
            //   const shopifyVariantId = repeatForm.shopifyVariantId;

            console.log("repeatProductId", repeatProductId);

            const intervalType = document.querySelector(".repeatIntervalType").dataset
                .currentValue;
            const intervalCount = document.querySelector(".repeatIntervalCount")
                .dataset.currentValue;

            formData.items[0].properties = {
                [translateLabel(
                    "frequency",
                    selectedLanguage
                )]: `${intervalCount} ${translateLabel(
                    intervalType,
                    selectedLanguage
                )} ${translateLabel("apart", selectedLanguage)}`,
                _repeat_interval_type: intervalType,
                _repeat_interval_count: intervalCount,
                _repeat_product: repeatProductId,
            };
        } else {
            // add selling plan if we have one
            if (sellingPlan) {
                formData.items[0].selling_plan = parseInt(sellingPlan);
            }
        }

        // add product
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        // open cart
        await openCart();
    });

// update product
updateProduct();
